var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6186 6.66529H3.73633L5.55359 4.86052C5.8094 4.60646 5.8094 4.19462 5.55359 3.94057C5.2977 3.68644 4.88309 3.68651 4.6272 3.94057L1.69186 6.85589C1.43605 7.10994 1.43605 7.52178 1.69186 7.77584L4.6272 10.691C4.75514 10.8181 4.92275 10.8815 5.09036 10.8815C5.25797 10.8815 5.42557 10.818 5.55351 10.691C5.80933 10.437 5.80933 10.0251 5.55351 9.77106L3.73626 7.96629H12.6185C14.0364 7.96629 15.19 9.11196 15.19 10.5201C15.19 11.9283 14.0364 13.074 12.6185 13.074H7.21532C6.85354 13.074 6.56032 13.3652 6.56032 13.7245C6.56032 14.0838 6.85354 14.375 7.21532 14.375H12.6185C14.7587 14.375 16.5 12.6457 16.5 10.5201C16.5 8.39461 14.7588 6.66529 12.6186 6.66529Z",
    fill: "#1F4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.8bab676e1c41078d7c2cdd3622ed3cde.svg";
export { ForwardRef as ReactComponent };